<template>
  <v-dialog :value="value" max-width="800" style="height: 60vh" scrollable>
    <v-card>
      <v-card-title>
        <span class="headline"
          >{{ translate("cash_register") }} -
          {{ formatDate(cashRegister?.creation_date_time ?? new Date()) }}</span
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4" class="d-flex pt-5">
            <v-text-field
              v-if="isCreate"
              :disabled="cashRegisterDateNotToday"
              v-model="form.in_cash"
              dense
              :label="translate('in_cash')"
              type="text"
              :hide-details="true"
              @keydown="(e) => handleInput(e, 'float')"
              @mouseenter="(event) => event.target.select()"
              @click="(event) => event.target.select()"
            />
            <v-text-field
              v-else
              :disabled="cashRegisterDateNotToday"
              v-model="cashRegister.in_cash"
              dense
              :label="translate('in_cash')"
              type="text"
              :hide-details="true"
              @keydown="(e) => handleInput(e, 'float')"
              @mouseenter="(event) => event.target.select()"
              @click="(event) => event.target.select()"
            />
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4" class="d-flex pt-5">
            <v-text-field
              v-if="isCreate"
              :disabled="cashRegisterDateNotToday"
              v-model="form.out_cash"
              dense
              :label="translate('out_cash')"
              type="text"
              :hide-details="true"
            />
            <v-text-field
              v-else
              :disabled="cashRegisterDateNotToday"
              v-model="cashRegister.out_cash"
              dense
              :label="translate('out_cash')"
              type="text"
              :hide-details="true"
            />
          </v-col>
        </v-row>
        <v-row>
          <span style="color: #2196f3; font-size: 18px" class="pl-3 pl-2">
            {{ $t("cash_register_section.today") }}
          </span>
        </v-row>
        <v-row class="mt-n3">
          <v-col cols="12">
            <v-simple-table>
              <thead>
                <tr>
                  <th>{{ translate("monetary_euro") }}</th>
                  <th>{{ translate("count") }}</th>
                  <th>{{ translate("total_euro") }}</th>
                </tr>
              </thead>
              <tbody v-if="cashRegister">
                <tr v-for="detail in cashRegisterDetails" :key="detail.id">
                  <td>{{ detail.monetary_figure.name }}</td>
                  <td>
                    <v-text-field
                      :disabled="cashRegisterDateNotToday"
                      v-model="detail.quantity"
                      dense
                      type="text"
                      style="width: 60px"
                      @keydown="(e) => handleInput(e, 'int')"
                      @mouseenter="(event) => event.target.select()"
                      @click="(event) => event.target.select()"
                    />
                  </td>
                  <td>
                    {{
                      parseFloat(
                        detail.quantity * detail.monetary_figure.value
                      ).toFixed(2)
                    }}
                  </td>
                </tr>
                <tr class="summary-row summary-row--counted">
                  <td></td>
                  <td>{{ translate("counted_cash") }}</td>
                  <td class="summary-value">{{ totalCashTodayIn }}</td>
                </tr>
                <tr class="summary-row">
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="summary-row summary-row--add">
                  <td></td>
                  <td>+ {{ translate("in_cash") }}</td>
                  <td class="summary-value">{{ totalInCashToday }}</td>
                </tr>
                <tr class="summary-row summary-row--subtract">
                  <td></td>
                  <td>− {{ translate("out_cash") }}</td>
                  <td class="summary-value">{{ totalOutCashToday }}</td>
                </tr>
                <tr class="summary-row summary-row--total">
                  <td></td>
                  <td>{{ translate("register_balance") }}</td>
                  <td class="summary-value">{{ summaryBalance }}</td>
                </tr>
              </tbody>

              <tbody v-if="!cashRegister && monetary_figures">
                <tr v-for="figure in monetary_figures" :key="figure.id">
                  <td>{{ figure.name }}</td>
                  <td>
                    <v-text-field
                      :disabled="cashRegisterDateNotToday"
                      v-model="figure.quantity"
                      dense
                      type="text"
                      style="width: 60px"
                      @keydown="(e) => handleInput(e, 'int')"
                      @mouseenter="(event) => event.target.select()"
                      @click="(event) => event.target.select()"
                    />
                  </td>
                  <td>
                    {{ parseFloat(figure.quantity * figure.value).toFixed(2) }}
                  </td>
                </tr>
                <tr class="summary-row summary-row--counted">
                  <td></td>
                  <td>{{ translate("counted_cash") }}</td>
                  <td class="summary-value">{{ totalCashTodayIn }}</td>
                </tr>
                <tr class="summary-row summary-row--add">
                  <td></td>
                  <td>+ {{ translate("in_cash") }}</td>
                  <td class="summary-value">{{ totalInCashToday }}</td>
                </tr>
                <tr class="summary-row summary-row--subtract">
                  <td></td>
                  <td>− {{ translate("out_cash") }}</td>
                  <td class="summary-value">{{ totalOutCashToday }}</td>
                </tr>
                <tr class="summary-row summary-row--total">
                  <td></td>
                  <td>{{ translate("register_balance") }}</td>
                  <td class="summary-value">{{ summaryBalance }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <span
          class="mx-2"
          @click="deleteCashRegister"
          v-if="!isCreate"
        >
          <v-btn :loading="loading" :disabled="loading" color="error">
            {{ $t("cash_register_section.delete") }}
            <v-icon dark right>mdi-delete</v-icon>
          </v-btn>
        </span>
        <v-spacer></v-spacer>
        <span class="mx-2" @click="printCashRegister" v-if="!isCreate && isAdmin"
          ><v-btn :loading="loading" :disabled="loading" color="primary">
            {{ $t("cash_register_section.print_report") }}
            <v-icon dark right> mdi-printer </v-icon>
          </v-btn>
        </span>
        <span @click="close"> <CloseButton :disabled="loading" /> </span>
        <span class="mx-2" @click="createCashRegister" v-if="isCreate"
          ><SaveButton :loading="loading" :disabled="loading"
        /></span>
        <span class="mx-2" @click="updateCashRegister" v-else
          ><SaveButton :loading="loading" :disabled="loading"
        /></span>
      </v-card-actions>
    </v-card>
    <confirmation-model
      v-if="confirmationDialog"
      :showDialog.sync="confirmationDialog"
      :openedForOperation.sync="confirmationDialogOperation"
      :text.sync="confirmationDialogConfirmationText"
      :trueText.sync="confirmationDialogTrueText"
      :falseText.sync="confirmationDialogFalseText"
      @buttonClicked="
        (event) =>
          confirmationButtonClicked(event, () => performDeleteCashRegister())
      "
    ></confirmation-model>
  </v-dialog>
</template>
<script>
import CloseButton from "@/components/Buttons/CloseButton.vue";
import _axios from "@/plugins/axios";
import { API_BASE_URL } from "@/config";
import moment from "moment";
import SaveButton from "@/components/Buttons/SaveButton.vue";
import confirmationModelMixin from "@/mixins/ConfirmationModelMixin";
export default {
  name: "CashRegisterModal",
  components: { SaveButton, CloseButton },
  mixins: [confirmationModelMixin],
  emits: ["input", "cash"],
  data() {
    return {
      monetary_figures: [],
      hoveredCol: null,
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
      timerId: null,
      form: {
        in_cash: 0,
        out_cash: 0,
      },
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    cashRegister: {
      type: Object,
      default: null,
    },
    lastCashRegister: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.getMonetaryFigures();
    if (this.isCreate && this.lastCashRegister) {
      this.form.in_cash = this.lastCashRegister.cash_counted || 0;
      this.form.out_cash = 0;
    }
  },
  watch: {
    value(val) {
      if (!val) {
        this.resetForm();
      }
    },
  },
  activated() {
    this.getMonetaryFigures();
  },
  computed: {
    loading() {
      return this.$store.state.isLoading;
    },
    todaysDate() {
      return moment().format("YYYY-MM-DD");
    },
    cashRegisterDateNotToday() {
      //Temporarily return false to allow editing of cash register
      return false;

      // if(!this.cashRegister){
      //   return false
      // }
      //
      // return moment(this.cashRegister?.creation_date_time).format('YYYY-MM-DD') !== this.todaysDate
    },
    cashRegisterDetails() {
      if (this.isCreate) {
        return this.monetary_figures.map((mf) => {
          return {
            monetary_figure_id: mf.id,
            quantity: 0,
          };
        });
      }
      return this.cashRegister?.details || [];
    },
    isCreate() {
      return !this.cashRegister;
    },
    grandTotal() {
      if (!this.cashRegister) {
        return 0;
      }

      return parseFloat(
        this.cashRegisterDetails.reduce(
          (acc, detail) => acc + detail.quantity * detail.monetary_figure.value,
          0
        ) +
          parseFloat(this.cashRegister.in_cash || 0) -
          parseFloat(this.cashRegister.out_cash || 0)
      ).toFixed(2);
    },
    grandTotalNew() {
      return parseFloat(
        this.monetary_figures.reduce(
          (acc, detail) => acc + detail.quantity * detail.value,
          0
        ) +
          parseFloat(this.form.in_cash || 0) -
          parseFloat(this.form.out_cash || 0)
      ).toFixed(2);
    },
    totalCounterIn() {
      if (this.isCreate) {
        return this.monetary_figures.reduce((acc, detail) => {
          return acc + parseFloat(detail.quantity || 0);
        }, 0);
      }
      return this.cashRegisterDetails.reduce((acc, detail) => {
        return acc + parseFloat(detail.quantity || 0);
      }, 0);
    },
    totalCashTodayIn() {
      if (this.isCreate) {
        return parseFloat(
          this.monetary_figures.reduce((acc, detail) => {
            return acc + detail.quantity * detail.value;
          }, 0)
        ).toFixed(2);
      }
      return parseFloat(
        this.cashRegisterDetails.reduce((acc, detail) => {
          return acc + detail.quantity * detail.monetary_figure.value;
        }, 0)
      ).toFixed(2); 
    },
    totalInCashToday() {
      if (this.isCreate) {
        return parseFloat(this.form.in_cash || 0).toFixed(2);
      }
      return parseFloat(this.cashRegister.in_cash || 0).toFixed(2);
    },
    totalOutCashToday() {
      if (this.isCreate) {
        return parseFloat(this.form.out_cash || 0).toFixed(2);
      }
      return parseFloat(this.cashRegister.out_cash || 0).toFixed(2);
    },
    summaryBalance() {
      return this.isCreate ? this.grandTotalNew : this.grandTotal;
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    updateCashRegisterDetail(detail) {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      this.timerId = setTimeout(() => {
        return new Promise((resolve) => {
          return _axios
            .put(API_BASE_URL + "/company_cash_register/details/" + detail.id, {
              quantity: detail.quantity,
            })
            .then(({ data }) => {
              // let index = this.cashRegister.details.findIndex(d => d.id === detail.id)
              // this.cashRegister.details[index] = data
              this.$emit("cash", {
                cash_register_id: this.cashRegister.id,
                cash: data,
              });
              resolve(data);
            });
        });
      }, 1000);
    },
    createCashRegister() {
      // if all values are 0, stop
      if (
        this.monetary_figures.every((mf) => mf.quantity === 0) &&
        this.form.in_cash === 0
      ) {
        this.$toast.error(this.translate("no_data_provided"));
        return;
      }
      return new Promise((resolve) => {
        this.$store.state.isLoading = true;
        return _axios
          .post(API_BASE_URL + "/company_cash_register", {
            in_cash: this.form.in_cash || 0,
            out_cash: this.form.out_cash || 0,
            creation_date_time: moment().format("YYYY-MM-DD HH:mm:ss"),
            details: this.monetary_figures.map((detail) => {
              return {
                monetary_figure_id: detail.id,
                quantity: detail.quantity,
              };
            }),
          })
          .finally(() => (this.$store.state.isLoading = false))
          .then(({ data }) => {
            this.$emit("cash", data.data);
            this.$toast.success(this.translate("added_successfully"));
            this.close();
            this.resetForm();
            // if route is not cash register, redirect to cash register
            if (this.$route.name !== "CashRegisterListing") {
              this.$router.push({ name: "CashRegisterListing" });
            }
            resolve(data);
          });
      });
    },
    updateCashRegister() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      return new Promise((resolve) => {
        this.$store.state.isLoading = true;
        return _axios
          .put(
            API_BASE_URL + "/company_cash_register/" + this.cashRegister.id,
            {
              in_cash: this.cashRegister.in_cash || 0,
              out_cash: this.cashRegister.out_cash || 0,
              details: this.cashRegisterDetails.map((detail) => {
                return {
                  id: detail.id,
                  quantity: detail.quantity,
                };
              }),
            }
          )
          .finally(() => (this.$store.state.isLoading = false))
          .then(({ data }) => {
            this.$emit("cash", data.data);
            this.$toast.success(this.translate("updated_successfully"));
            this.close();
            this.resetForm();
            resolve(data);
          });
      });
    },
    getMonetaryFigures() {
      return new Promise((resolve) => {
        return _axios
          .get(API_BASE_URL + "/monetary_figures", { headers: this.header })
          .then(({ data }) => {
            this.monetary_figures = data.data.map((i) => {
              i.quantity = 0;
              return i;
            });
            resolve(data);
          });
      });
    },
    resetForm() {
      this.form = {
        in_cash: 0,
        out_cash: 0,
      };

      this.monetary_figures = this.monetary_figures.map((mf) => {
        mf.quantity = 0;
        return mf;
      });
      this.cashRegister = null;
    },
    translate(key) {
      return this.$t("cash_register_section." + key);
    },
    printCashRegister() {
      if (this.cashRegister) {
        this.$store.state.isLoading = true;
        return _axios
          .put(
            API_BASE_URL + "/company_cash_register/" + this.cashRegister.id,
            {
              in_cash: this.cashRegister.in_cash || 0,
              out_cash: this.cashRegister.out_cash || 0,
              details: this.cashRegisterDetails.map((detail) => {
                return {
                  id: detail.id,
                  quantity: detail.quantity,
                };
              }),
            }
          )
          .finally(() => (this.$store.state.isLoading = false))
          .then(({ data }) => {
            this.$emit("cash", data.data);
            let url =
              API_BASE_URL +
              "/company_cash_register/" +
              this.cashRegister.id +
              "/report?lang=" +
              (localStorage.getItem("languageId") || "en") +
              "&user=" +
              localStorage.getItem("loginUserId");
            let fileName = this.cashRegister
              ? "Cash_Register_" +
                moment(this.cashRegister.creation_date_time).format(
                  "YYYY-MM-DD_HH-mm-ss"
                )
              : "Cash_Register";
            this.setPreviewData(url, fileName, true, "application/pdf");
          });
      }
    },
    deleteCashRegister() {
      if (!this.cashRegister) {
        return;
      }
      this.popConfirmation(
        this.translate("delete_confirmation"),
        "deleteCashRegister"
      );
    },
    performDeleteCashRegister() {
      if (!this.cashRegister) {
        return;
      }
      this.$store.state.isLoading = true;
      return _axios
        .delete(
          API_BASE_URL + "/company_cash_register/" + this.cashRegister.id
        )
        .finally(() => (this.$store.state.isLoading = false))
        .then(() => {
          this.$emit("cash", {
            id: this.cashRegister.id,
            deleted: true,
          });
          this.$toast.success(this.translate("deleted_successfully"));
          this.close();
          this.resetForm();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.summary-row {
  font-weight: bolder;
  font-size: 30px;
}

.summary-row td {
  color: #424242;
}

.summary-row--counted td {
  border-top: 2px solid black !important;
  border-bottom: 2px solid black !important;
  background-color: rgb(231, 231, 231);
}

.summary-row--add td {
  color: #2e7d32;
}

.summary-row--subtract td {
  color: #c62828;
}

.summary-row--total td {
  color: #1565c0;
}

.summary-value {
  font-variant-numeric: tabular-nums;
}
</style>
